import { ImgBlock, InfoBlock } from './styles';
import { lighten, Typography, useTheme } from '@mui/material';
import { getContrastRatio } from '@mui/material/styles';
import React from 'react';
import InfoIcon from '../Icons/InfoIcon';

export const Info = () => {
	const theme = useTheme();
	const backgroundColor = theme.palette.primary.light;
	const secondaryColor = theme.palette.text.secondary;
	// Determine text color based on contrast ratio with background
	const whiteContrast = getContrastRatio('#ffffff', backgroundColor);
	const blackContrast = getContrastRatio(secondaryColor, backgroundColor);
	const textColor = whiteContrast > blackContrast ? '#ffffff' : '#000000';
	
	return (
		<InfoBlock>
			<ImgBlock>
				<InfoIcon htmlColor={lighten(theme.palette.primary.light, 0.4)} sx={{ width: 34, height: 34 }}/>
			</ImgBlock>
			<Typography variant="body1" sx={{ color: textColor }}>
				A loss is any time there's been a theft, injury or damage to property, whether it was covered or not.
			</Typography>
		</InfoBlock>
	)
}
